

export function calculateTotalScores(tournament) {
    const scores = {};
    const teamIds = Object.keys(tournament.teams);

    // Inicializar a cero
    teamIds.forEach((teamId) => {
        scores[teamId] = 0;
    });

    // Sumar puntos por partido acabado
    tournament.sessions.forEach((session) => {
        session.matches.forEach((match) => {
            if (match.status === 'finished') {
                if (match.result.winner) {
                    scores[match.result.winner] += 1;
                } else {
                    // Empate: 0.5 para cada equipo
                    teamIds.forEach((teamId) => {
                        scores[teamId] += 0.5;
                    });
                }
            }
        });
    });

    return scores;
}

export function cn(...classes) {
    return classes.filter(Boolean).join(' ');
}
